import {Vision} from '../../vision/message/Vision';

export class FreeDataCartesianBuilder {
criteria: {[key: string]: string[]};
fdvs: {[key: string]: string[]};
stepLevels: number[];
vision: Vision;
}

